module.exports = __webpack_public_path__ + "img/layout_right_icon.5adb936f.svg";